import { Clock, CheckCircle, XCircle, Eye, RotateCcw } from 'lucide-react';
export const RelatedArticles = ({ articles }) => {
  const styles = {
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      padding: '32px'
    },
    title: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#1f2937',
      marginBottom: '24px'
    },
    articleTitle: {
      fontWeight: '600',
      color: '#2563eb',
      marginBottom: '8px',
      cursor: 'pointer'
    },
    articleTitleHover: {
      color: '#1e40af'
    },
    articleDescription: {
      fontSize: '14px',
      color: '#4b5563'
    }
  };

  return (
    <div style={styles.card}>
      <h3 style={styles.title}>Related Topics</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {articles.map((article, index) => (
          <div key={index} style={{ 
            borderBottom: '1px solid #e5e7eb', 
            paddingBottom: '16px', 
            ...(index === articles.length - 1 && { borderBottom: 'none' })
          }}>
            <h4 style={{
              ...styles.articleTitle,
              ':hover': styles.articleTitleHover
            }}>
              {article.title}
            </h4>
            <p style={styles.articleDescription}>{article.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};